import React from 'react';
import {
  createBrowserRouter,
  RouterProvider
} from 'react-router-dom';
import ReactDOM from 'react-dom/client';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import App from './App';
import Terms from './Terms';
import SmsTerms from './SmsTerms';
import EmailTerms from './EmailTerms';
import Privacy from './Privacy';
import ScrollToTop from './ScrollToTop';

const router = createBrowserRouter([
  {
    path: '/',
    element: <GoogleReCaptchaProvider reCaptchaKey={process.env.REACT_APP_RECAPTCHA_KEY}><App/></GoogleReCaptchaProvider>,
  },
  {
    path: '/terms',
    element: (<ScrollToTop element={<Terms/>} />),
  },
  {
    path: '/sms-terms',
    element: (<ScrollToTop element={<SmsTerms/>} />),
  },
  {
    path: '/email-terms',
    element: (<ScrollToTop element={<EmailTerms/>} />),
  },
  {
    path: '/privacy',
    element: (<ScrollToTop element={<Privacy/>} />),
  },
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <RouterProvider router={router} />
  </React.StrictMode>
);
